import { render, staticRenderFns } from "./EncounterPatientPage.vue?vue&type=template&id=3ccbb358&scoped=true&"
import script from "./EncounterPatientPage.vue?vue&type=script&lang=js&"
export * from "./EncounterPatientPage.vue?vue&type=script&lang=js&"
import style0 from "./EncounterPatientPage.vue?vue&type=style&index=0&id=3ccbb358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccbb358",
  null
  
)

export default component.exports